export const chartMixin = {
  data() {
    return {
      line_chart_datasets: [],
      line_chart_labels: [],
      line_chart_times: [],
      line_chart_scales: {
        x: {
          display: true,
          stacked: true,
          ticks: {
            callback: (value, index, ticks) => this.scalesXTicks(value, index, ticks),
            fontSize: 99,
          },
        },
        y: {
          display: true,
          type: "linear",
          position: "left",
          suggestedMin: 0,
          suggestedMax: 10,
          ticks: {
            callback: (value, values, ctx) => this.scalesYTicks(value, values, ctx),
          },
        },
      },
      line_chart_plugins: {
        legend: {
          labels: {
            boxWidth: 4,
            boxHeight: 4,
            padding: 10,
            textAlign: 'center',
            useBorderRadius: true,
            borderRadius: 2
          },
        },
        // 移到點上的提示框，顯示點的時間
        tooltip: {
          callbacks: {
            title: (context) => this.tooltipTitle(context),
            label: (context) => this.tooltipLabel(context),
          },
        },
      },
      bar_chart_datasets: [],
      bar_chart_labels: [],
      // pie chart
      pie_chart_params: {},
      pie_chart_body: null,
      pie_chart_colors: [],
      pie_chart_arcAngle: '',
      pie_chart_getBodyWidth: '',
      pie_chart_getBodyHeight: '',
      pie_chart_current: '',
    }
  },
  mounted() {
    console.log('### chart-mixin mounted');
  },
  computed: {
    line_chart_config() {
      return {
        data: {
          labels: this.line_chart_labels,
          times: this.line_chart_times,
          datasets: this.line_chart_datasets,
        },
        options: {
          maintainAspectRatio: false,
          scales: this.line_chart_scales,
          plugins: this.line_chart_plugins,
        },
      };
    },
    bar_chart_config() {
      return {
        type: "bar",
        data: {
          labels: this.bar_chart_labels,
          datasets: this.bar_chart_datasets,
        },
        options: {
          maintainAspectRatio: false,
        },
      };
    },
  },
  methods: {
    scalesXTicks(value, index, ticks) {
      if (this.picked_unit === 'electricity' || this.$store.getters.historicalDataTimeFormat !== 'day') {
        return this.line_chart_labels[index];
      } else {
        if (index % 6 === 0) {
          return this.line_chart_labels[index];
        }
      }
    },
    scalesYTicks(value, index, ticks) {
      return value.toFixed(2);
    },
    tooltipTitle(context) {
      return (
        this.line_chart_times[context[0].dataIndex] ??
        this.line_chart_labels[context[0].dataIndex]
      );
    },
    tooltipLabel(context) {
      if (context.dataset.label == "電流(Ampere)") {
        return " " + context.raw + " " + "A";
      } else {
        return " " + context.raw + " " + "KWatt";
      }
    },
    RGBformat(scaleColor, a = 1) {
      if (a < 1) {
        return `rgba(${scaleColor.r}, ${scaleColor.g}, ${scaleColor.b}, ${a})`;
      } else {
        return `rgba(${scaleColor.r}, ${scaleColor.g}, ${scaleColor.b}, ${scaleColor.a})`;
      }
    },
    // render pie chart
    renderPieChart() {
      const width = this.pie_chart_params.width;
      const height = this.pie_chart_params.width;
      const config = this.pie_chart_params.config;
      let svg = this.pie_chart_params.svg;
      const scaleColors = this.pie_chart_params.scaleColors;

      this.pie_chart_body = svg
        .append("svg")
        .attr("id", "pie-svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("class", "body")
        .attr(
          "transform",
          "translate(" + config.margin.left + "," + config.margin.top + ")"
        )
        .attr("clip-path", "url(#clip)");

      this.pie_chart_colors = d3.scaleOrdinal(scaleColors);

      /* ----------------------------尺度轉換------------------------  */
      this.pie_chart_arcAngle = d3
        .pie()
        .sort((d, i) => i)
        .value((d) => d.cumulative_ep);

      this.pie_chart_getBodyWidth = width;
      this.pie_chart_getBodyHeight =
        height - (config.margin.top + config.margin.bottom) ?? 0;

      // this.renderLegend();
      this.renderSlices();
    },
    renderSlices() {
      const slices = this.pie_chart_body
        .append("g")
        .classed("pie", true)
        .attr(
          "transform",
          "translate(" + this.pie_chart_getBodyWidth / 2 + "," + this.pie_chart_getBodyHeight / 2 + ")"
        )
        .selectAll(".arc")
        .data(this.pie_chart_arcAngle(this.pie_chart_params.data));

      slices
        .enter()
        .append("path")
        .attr("class", (d, i) => "arc arc-" + i)
        .merge(slices)
        .attr("fill", (d, i) => this.pie_chart_colors(i))
        .transition()
        .duration(this.pie_chart_params.config.animateDuration)
        .attrTween("d", arcTween);

      slices.exit().remove();

      const arc = d3
        .arc()
        .outerRadius(this.pie_chart_params.config.outerRadius)
        .innerRadius(this.pie_chart_params.config.innerRadius);

      function arcTween(d) {
        let currentArc = this.pie_chart_current;

        if (!currentArc) {
          currentArc = { startAngle: 0, endAngle: 0 };
        }

        const interpolate = d3.interpolate(currentArc, d);
        // 當資料更新時，從目前角度過渡到新角度
        this.pie_chart_current = interpolate(1);

        return function (t) {
          return arc(interpolate(t));
        };
      }
    },
    renderLegend() {
      const legendItemSize = this.pie_chart_params.legendItemSize;
      const legendSpacing = this.pie_chart_params.legendSpacing;
      const legend = d3
        .select("#pieLegend")
        .append("svg")
        .attr("id", "legend-svg")
        // .attr('width', "180")
        // .attr('height', "110")
        .selectAll(".legendItem")
        .data(this.pie_chart_params.data);

      // create legend items as circles instead of rectangles
      legend
        .enter()
        .append("circle") // Change this from "rect" to "circle"
        .attr("class", "legendItem")
        .attr("r", legendItemSize / 2) // Set radius of the circle
        .attr("cx", legendItemSize / 2) // Set x coordinate of the circle center
        .attr("cy", (d, i) => (legendItemSize / 2) + (legendItemSize + legendSpacing) * i) // Set y coordinate of the circle center
        .style("fill", (d, i) => this.pie_chart_colors(i));

      // Adjust the position of legend labels to align with circles
      legend
        .enter()
        .append('text')
        .attr('x', legendItemSize + 20)
        .attr('y', (d, i) => (legendItemSize + legendSpacing) * i + (legendItemSize / 2) + 7) // Adjust y position to align text with circle center
        .text((d) => d.alias);
    }
  },
};
